// $(document).ready(function(){
// 	if($('.team-lineup').length){
// 		$('.team-lineup').slick({
// 			infinite: true,
// 			centerMode: true,
// 			slidesToShow: 3,
// 			slidesToScroll: 1,
// 			dots: false,
// 			arrows: true,
// 			// draggable: false,
// 			focusOnSelect: true,
// 			variableWidth: true,
// 			appendArrows: '.team-carousel__navigation',
// 			asNavFor: '.team-bio'
// 		});

// 		$('.team-bio').slick({
// 			slidesToShow: 1,
// 			slidesToScroll: 1,
// 			dots: false,
// 			draggable: false,
// 			speed: 0,
// 			asNavFor: '.team-lineup',
// 			responsive: [
// 				{
// 				  breakpoint: 768,
// 				  settings: "unslick"
// 				}
// 			]
// 		});

// 		$('.slider-for-culture').slick({
// 		  slidesToShow: 1,
// 		  slidesToScroll: 1,
// 		  arrows: false,
// 		  dots: true,
// 		  fade: true,
// 		});
// 	}
// });

$(document).ready(function () {
	$('.js-slick-header').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		draggable: true,
		dots: false,
		arrows: false,
	});
	$('.news-slider').slick({
		dots: true,
		infinite: true,
		speed: 500,
		fade: true,
	});
	$('.js-slick-logos').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		autoplay: true,
		draggable: true,
		dots: true,
		arrows: false,
	});
	$('.home-hero-wrap').slick({
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 2000,
		fade: true,
	});
	$('.js-features-slider').slick({
		speed: 400,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		draggable: true,
		dots: true,
		arrows: false,
		autoplaySpeed: 10000,
		adaptiveHeight: true,
	});
	$('.philo-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		draggable: true,
		dots: true,
		arrows: false,
		fade: true,
	});
});

